export * from './app-icon.component';
